(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
    // .toki-card-actions__form is a plain native <form> (no fetch/JS
    // handling it - see the comment above the form in this file for why),
    // so unlike Dawn's own <product-form>, nothing here disables the button
    // once submitted. With no loading indicator either, a slow network
    // reads as "nothing happened" and invites a second tap/click - which,
    // since the browser dispatches an independent submit for each click on
    // an unprotected native form button, sends a second real /cart/add
    // request and doubles the line item. Delegate on document (many cards
    // render this same form) and disable on first submit only - the native
    // POST + Shopify's own redirect still does the rest untouched.
    if (window.__tokiCardBuyNowGuard) return;
    window.__tokiCardBuyNowGuard = true;

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target.closest('.toki-card-actions__form');
        if (!form) return;
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        button.disabled = true;
        button.classList.add('loading');
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
